export const stockTypeTitleMapper = (stockType) => {
    switch (stockType) {
      case 'Common Stock':
        return 'Stock'
  
      default:
        return stockType;
    }
  }